import { makeStyles } from '@material-ui/core/styles';

import { getColorWithOpacity } from '@/utils/colorHelpers.js';

export const useCustomAnamnesisStyles = makeStyles((theme) => ({
    defaultQuestion: {
        width: '100%',
        boxSizing: 'border-box',
        transition: 'background 0.3s ease, padding 0.3s ease, border 0.3s ease',
        borderRadius: theme.radius.default,
    },
    requiredIndicator: {
        border: `1px solid ${theme.palette.common.red}`,
        padding: 10,
    },
    highlight: {
        background: getColorWithOpacity(theme.palette.common.red, 0.08),
        border: `1px solid ${theme.palette.common.red}`,
        padding: 10,
    },
}));
